import React from 'react'
import { ImageIcon } from '@/icon'
import { Card } from '@mui/material'
import { styled, SxProps } from '@mui/material/styles'
import security_icon from '@/asset/img/security_icon.webp'
import account_bg from '@/asset/img/account_bg.webp'

export const BasicCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'view',
})<{ view: 'info' | 'form' }>(({ view = 'info' }) => ({
  padding: '24px 48px',
  display: 'flex',
  backgroundImage: `url(${account_bg})`,
  backgroundPositionX: 'right',
  backgroundPositionY: 'bottom',
  justifyContent: 'flex-start',
  backgroundSize: view === 'info' ? '40%' : '60%',
  backgroundRepeat: 'no-repeat',
  alignItems: 'center',
}))

export const Icon = ({ sx }: { sx: SxProps }) => {
  return <ImageIcon sx={sx} src={security_icon} />
}

export const Footer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '24px',
}))
